import * as actions from "actions";
import api from "api";
import * as Types from "Types";

const initialState = {
   get: {
      status: api.statuses.idle,
      code: 0,
      data: [],
      message: "",
   },
};

function sagaNowContents(state = initialState, { type, payload }: Types.Reducer) {
   switch (type) {
      case actions.nowContents.get.send:
         return {
            ...state,
            get: {
               status: api.statuses.pending,
               code: 0,
               data: [],
               message: "",
            },
         };
      case actions.nowContents.get.success:
         return {
            ...state,
            get: {
               status: api.statuses.resolved,
               code: payload.code,
               data: payload.data,
               message: "",
            },
         };
      case actions.nowContents.get.fail:
         return {
            ...state,
            get: {
               status: api.statuses.rejected,
               code: payload.code,
               data: [],
               message: payload.message,
            },
         };
      default:
         return state;
   }
}

export default sagaNowContents;

export const StateType = typeof initialState;
export { actions };
export { sagaNowContents };
